export const artistsArr = [

    //Abs

    [
      "Abscond",
      "https://open.spotify.com/artist/0uLmktR4BwnX4SrYCwy5Zy?si=aOo8G_efQKCTMXkGknVCmg",
      "https://soundcloud.com/hendricksxn"
    ],
  
    //BabyGlobin
    [
      "BabyGlobin",
      "https://open.spotify.com/artist/7vzQdt3N1n3MS4to7fnnz3?si=v5mWjfCJSMm6WjPK9r_xtQ",
      "https://soundcloud.com/maxmcphatter",
  
    ],

    //Bloodroot
    [
    "Bloodroot",
    "https://open.spotify.com/artist/2otF467XTCqt5lUhoILzWE?si=z5DJgNAPTMuk3Jbh6wiO8Q",
    "",
    ],
  
  
  //Chai
  
    [
      "Chai Sully",
      "https://open.spotify.com/artist/0y3P9lt6Di3q1s1SwcCFuK?si=y9r16kTzSb2tLqR7f_PSMw",
      "https://soundcloud.com/chaisully",
    ],
  
  //JnJKharia
  
    [
        "JnJKharia",
        "",
      "https://soundcloud.com/jnjkhaira",

    ],
    
  
  //Noturlover
    
    [
      "Noturlover",
      "https://open.spotify.com/artist/6CjC3EeGuy6uRh1G0K7njE?si=QBvV_MxATu6dNwl18CouQQ",
      "https://soundcloud.com/noturlover",


    ],
   
      // Purple Corporation 
  
      [
        "Purple Corporation",
        "https://open.spotify.com/artist/697of2Gitrw0anQy4eewrG?si=9QFJtML3RlCrkm0TbVBaRQ",
        "https://soundcloud.com/purplecorp"
      ],
  
    //Rod Lowkey
      [ 
        "Rod Lowkey",
        "",
        "https://soundcloud.com/rodlowkey26",
      ],

    // raleighrain
  
    [
        "Raleighrain",
        "",
        "https://soundcloud.com/hunter516"
      ],

  
      

 
       //Selah
       [
        "Selah",
        "",
        "https://soundcloud.com/iselahi"
      ],
    ];